import ServiceCategoryPage from "../components/ServiceCategoryPage";
import houseMaidService from "../data/services/houseMaidService";

function HouseMaid() {
  return <ServiceCategoryPage service={houseMaidService} />;
}

export default HouseMaid;